import { api } from "./httpClient";

export const agentService = {
  list(tenantId) {
    return api(`/v1/agents?tenantId=${encodeURIComponent(tenantId || "")}`).then((res) => res?.content || []);
  },
  save(payload) {
    return api(payload?.uuid ? `/v1/agents/${payload.uuid}` : "/v1/agents", {
      method: payload?.uuid ? "PUT" : "POST",
      body: JSON.stringify(payload),
    });
  },
remove(uuid) {
    return api(`/v1/agents/${uuid}`, { method: "DELETE" });
  },
  restore(uuid) {
    return api(`/v1/agents/${uuid}/restore`, { method: "POST" });
  },
};
